import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserState } from '@csgofast/core/state/user-store';
import { IUserDetailed } from '@dev-fast/types';
import { Select } from '@ngxs/store';
import { map, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BanActivateGuard implements CanActivate {
  @Select(UserState.user)
  public readonly user$!: Observable<IUserDetailed>;
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const path = route.routeConfig && route.routeConfig.path ? route.routeConfig.path : '';

    const allowedPath = ['support', 'account', 'block'];
    return this.user$.pipe(
      map((value) => {
        if (!!value && value.permLock) {
          if (allowedPath.some((el) => path.includes(el))) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      })
    );
  }
}
